import { render, staticRenderFns } from "./ImageAudioVideo.vue?vue&type=template&id=0316a4a6&scoped=true&"
import script from "./ImageAudioVideo.vue?vue&type=script&lang=js&"
export * from "./ImageAudioVideo.vue?vue&type=script&lang=js&"
import style0 from "./ImageAudioVideo.vue?vue&type=style&index=0&id=0316a4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0316a4a6",
  null
  
)

export default component.exports